var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticClass:"column__tool__buttom",attrs:{"type":"success","size":"mini","plain":"","icon":"el-icon-refresh-left"},on:{"click":_vm.DoStart}},[_vm._v("恢复 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }